/*
 * Copyright (c) 2020. American Express Company
 */

import React, { Component, ReactComponentElement } from 'react';

import { ReactComponent as BudgetIcon } from 'src/bw/bw-drawer/status-drawer/icons/budget.svg';
import MentorDialog from 'src/components/mentors/MentorDialog';
import MentorPopover from 'src/components/mentors/MentorPopover';

export default class Mentor extends Component<any> {
    public override render(): ReactComponentElement<any> {
        switch (this.props.mode) {
            case 'popover':
                return (
                    <MentorPopover
                        className={this.props.mentorClass}
                        mentorX={this.props.mentorX}
                        mentorY={this.props.mentorY}
                        dangerous={this.props.dangerous}
                        mentorHeight={this.props.mentorHeight}
                        position={this.props.position}
                        body={this.props.body}
                        buttonOneText={this.props.buttonOneText}
                        buttonOneHandler={this.props.buttonOneHandler}
                        buttonTwoText={this.props.buttonTwoText}
                        buttonTwoHandler={this.props.buttonTwoHandler}
                        learnMoreUrl={this.props.learnMore}
                        isOpen={this.props.open}
                        onKeyUp={this.onKeyUp}
                        anchor={this.props.anchor}
                    />
                );
            default:
                return (
                    <MentorDialog
                        mode={this.props.mode}
                        icon={this.props.icon || <BudgetIcon />}
                        headerText={this.props.header}
                        body={this.props.body}
                        position={this.props.position}
                        buttonOneText={this.props.buttonOneText}
                        buttonOneHandler={this.props.buttonOneHandler}
                        buttonTwoText={this.props.buttonTwoText}
                        buttonTwoHandler={this.props.buttonTwoHandler}
                        infoText={this.props.info}
                        className={this.props.mentorClass}
                        isOpen={this.props.open}
                        onKeyUp={this.onKeyUp}
                    />
                );
        }
    }

    private async dismiss(): Promise<void> {
        this.props.dismissMentors();
        if (this.props.dialogId) {
            await this.props.handleReloadUser();
        }
    }

    private async onKeyUp(event: any, onReturn: () => Promise<void>): Promise<void> {
        if (event.keyCode === 13) {
            if (onReturn) {
                await onReturn();
            } else {
                await this.dismiss();
            }
            event.preventDefault();
            event.stopPropagation();
        }
    }
}
